import { render } from "./App.vue?vue&type=template&id=fd7e7ab6&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fd7e7ab6&lang=css"
import "./App.vue?vue&type=style&index=1&id=fd7e7ab6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7e7ab6"]])

export default __exports__